import { render, staticRenderFns } from "./LPHeader.vue?vue&type=template&id=54173ef1&scoped=true"
import script from "./LPHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./LPHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LPHeader.vue?vue&type=style&index=0&id=54173ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54173ef1",
  null
  
)

export default component.exports